// extracted by mini-css-extract-plugin
export var filterIncDec = "_49-0";
export var leftBorder = "_49-1";
export var rightBorder = "_49-2";
export var stringInput = "_49-3";